import Component from "@glimmer/component";
import { getOwner, setOwner } from "@ember/owner";
import { service } from "@ember/service";
import Section from "./section";
import SectionLink from "./section-link";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class SidebarApiSection extends Component {
  static #_ = (() => dt7948.g(this.prototype, "sidebarState", [service]))();
  #sidebarState = (() => (dt7948.i(this, "sidebarState"), void 0))();
  constructor() {
    super(...arguments);
    this.section = new this.args.sectionConfig();
    setOwner(this.section, getOwner(this));
  }
  get shouldDisplay() {
    return !this.sidebarState.currentPanel.filterable || this.sidebarState.filter.length === 0 || this.filteredLinks.length > 0;
  }
  get filteredLinks() {
    if (!this.sidebarState.filter) {
      return this.section.links;
    }
    if (this.section.text.toLowerCase().match(this.sidebarState.sanitizedFilter)) {
      return this.section.links;
    }
    return this.section.links.filter(link1 => {
      return link1.text.toString().toLowerCase().match(this.sidebarState.sanitizedFilter) || link1.keywords.navigation.some(keyword1 => keyword1.match(this.sidebarState.filter));
    });
  }
  static #_2 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      {{#if this.shouldDisplay}}
        <Section
          @sectionName={{this.section.name}}
          @headerLinkText={{this.section.text}}
          @headerLinkTitle={{this.section.title}}
          @headerActionsIcon={{this.section.actionsIcon}}
          @headerActions={{this.section.actions}}
          @willDestroy={{this.section.willDestroy}}
          @collapsable={{@collapsable}}
          @displaySection={{this.section.displaySection}}
          @hideSectionHeader={{this.section.hideSectionHeader}}
          @collapsedByDefault={{this.section.collapsedByDefault}}
        >
          {{#each this.filteredLinks key="name" as |link|}}
            <SectionLink
              @linkName={{link.name}}
              @linkClass={{link.classNames}}
              @route={{link.route}}
              @model={{link.model}}
              @query={{link.query}}
              @models={{link.models}}
              @href={{link.href}}
              @title={{link.title}}
              @contentCSSClass={{link.contentCSSClass}}
              @prefixColor={{link.prefixColor}}
              @prefixBadge={{link.prefixBadge}}
              @prefixType={{link.prefixType}}
              @prefixValue={{link.prefixValue}}
              @prefixCSSClass={{link.prefixCSSClass}}
              @suffixType={{link.suffixType}}
              @suffixValue={{link.suffixValue}}
              @suffixCSSClass={{link.suffixCSSClass}}
              @hoverType={{link.hoverType}}
              @hoverValue={{link.hoverValue}}
              @hoverAction={{link.hoverAction}}
              @hoverTitle={{link.hoverTitle}}
              @currentWhen={{link.currentWhen}}
              @didInsert={{link.didInsert}}
              @willDestroy={{link.willDestroy}}
              @content={{link.text}}
              @contentComponent={{component
                link.contentComponent
                status=link.contentComponentArgs
              }}
            />
          {{/each}}
        </Section>
      {{/if}}
    
  */
  {
    "id": "l+72wPfx",
    "block": "[[[1,\"\\n\"],[41,[30,0,[\"shouldDisplay\"]],[[[1,\"      \"],[8,[32,0],null,[[\"@sectionName\",\"@headerLinkText\",\"@headerLinkTitle\",\"@headerActionsIcon\",\"@headerActions\",\"@willDestroy\",\"@collapsable\",\"@displaySection\",\"@hideSectionHeader\",\"@collapsedByDefault\"],[[30,0,[\"section\",\"name\"]],[30,0,[\"section\",\"text\"]],[30,0,[\"section\",\"title\"]],[30,0,[\"section\",\"actionsIcon\"]],[30,0,[\"section\",\"actions\"]],[30,0,[\"section\",\"willDestroy\"]],[30,1],[30,0,[\"section\",\"displaySection\"]],[30,0,[\"section\",\"hideSectionHeader\"]],[30,0,[\"section\",\"collapsedByDefault\"]]]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"filteredLinks\"]]],null]],null],\"name\",[[[1,\"          \"],[8,[32,1],null,[[\"@linkName\",\"@linkClass\",\"@route\",\"@model\",\"@query\",\"@models\",\"@href\",\"@title\",\"@contentCSSClass\",\"@prefixColor\",\"@prefixBadge\",\"@prefixType\",\"@prefixValue\",\"@prefixCSSClass\",\"@suffixType\",\"@suffixValue\",\"@suffixCSSClass\",\"@hoverType\",\"@hoverValue\",\"@hoverAction\",\"@hoverTitle\",\"@currentWhen\",\"@didInsert\",\"@willDestroy\",\"@content\",\"@contentComponent\"],[[30,2,[\"name\"]],[30,2,[\"classNames\"]],[30,2,[\"route\"]],[30,2,[\"model\"]],[30,2,[\"query\"]],[30,2,[\"models\"]],[30,2,[\"href\"]],[30,2,[\"title\"]],[30,2,[\"contentCSSClass\"]],[30,2,[\"prefixColor\"]],[30,2,[\"prefixBadge\"]],[30,2,[\"prefixType\"]],[30,2,[\"prefixValue\"]],[30,2,[\"prefixCSSClass\"]],[30,2,[\"suffixType\"]],[30,2,[\"suffixValue\"]],[30,2,[\"suffixCSSClass\"]],[30,2,[\"hoverType\"]],[30,2,[\"hoverValue\"]],[30,2,[\"hoverAction\"]],[30,2,[\"hoverTitle\"]],[30,2,[\"currentWhen\"]],[30,2,[\"didInsert\"]],[30,2,[\"willDestroy\"]],[30,2,[\"text\"]],[50,[30,2,[\"contentComponent\"]],0,null,[[\"status\"],[[30,2,[\"contentComponentArgs\"]]]]]]],null],[1,\"\\n\"]],[2]],null],[1,\"      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"@collapsable\",\"link\"],false,[\"if\",\"each\",\"-track-array\",\"component\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/api-section.js",
    "scope": () => [Section, SectionLink],
    "isStrictMode": true
  }), this))();
}